import React from 'react';
import classnames from 'classnames';

const BudgetTotalBar = ({
  children,
  isPurple = false,
  isError = false,
  label = null,
  hideTooltip = false,
  value,
  widthValue,
  toggleInfoModal,
  minLabel,
  maxLabel,
}) => (
  <div className="budget-toolbar-parent-container">
    <div className="c-total-bar-header">
      { children }

      {
        toggleInfoModal &&
          <span className="c-total-bar__info-trigger" onClick={() => toggleInfoModal()}>
            <i className="fa fa-info-circle u-text-pink" />
          </span>
      }
    </div>
    <div className={classnames('c-total-bar', { 'c-total-bar--purple': isPurple } )}>
      {
        (widthValue > 0 && !hideTooltip) &&
          <div className={
            classnames('c-total-bar__tip', {
              'c-total-bar__tip--small': !label
              }
            )}
            style={{ left: `${widthValue}%` }}
          >
            <p className="c-total-bar__tip-title">
              {
                label && (
                  <span>{label}<br/></span>
                )
              }
              <span className="c-total-bar__tip-value">{value}</span>
            </p>
          </div>
      }

      <div className="c-total-bar__min-max-wrap">
        { minLabel && <span className="c-total-bar__min-value">{minLabel}</span> }
        { maxLabel && <span className="c-total-bar__max-value">{maxLabel}</span> }
      </div>

      <div
        className={classnames('c-total-bar__value', {
          'c-total-bar__value--error': isError,
        })}
        style={{ width: `${(widthValue > 100) ? 100 : widthValue}%` }}
      />
    </div>
  </div>
);

export default BudgetTotalBar;



// WEBPACK FOOTER //
// ./src/components/budget-total-bar/BudgetTotalBar.jsx